/*!

=========================================================
* BootstrapVue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import VueI18n from "vue-i18n";
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
// router setup
import router from './routes/router';
//import router from './routes/MinaSidorRouter';
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueI18n);

let locale = window.location.pathname.replace(/^\/([^\/]+).*/i, "$1");
locale = locale == "admin" ? "sv" : locale;
import messages from "./lang/i18n";
console.log(locale);
const i18n = new VueI18n({
  locale: locale, // set locale
  messages, // set locale messages
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router: router,
  i18n: i18n,
});
